import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import hash from '../../../helpers/hash';
import config from '../../../helpers/config';

const useStyles = makeStyles(theme => ({

    descTitle: props => ({
        height: '20%',
        marginTop: '20px',
        '& h3': {
            backgroundColor: hash.walk('theme.primary', props) || 'white',
            color: 'white',
            letterSpacing: '5px',
            width: '60%',
            margin: '0 auto',
            borderRadius: '20px',

            
            [theme.breakpoints.down("xs")]: {
                width: '80%',
            },
        }
    }),

    descContent: props => ({
        padding: '40px 40px 0px 40px',
        height: '80%',

        '& h4': {
            fontWeight: 500,
            letterSpacing: '3px'
        }
    }),

    bannerImg: {
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '80vh',

        [theme.breakpoints.down('sm')]: {
            backgroundSize: 'contain',
            backgroundPosition: 'top',
            height: 'calc(100vw * 0.55)',
        }
    },

    bannerDescDiv: {
        padding: '20px',

        [theme.breakpoints.down("xs")]: {
            padding: '0px',
        },

    },

    baneerTextContainer: {
        border: '5px solid #818181',
        height: '100%',
        textAlign: 'center',
        padding: '30px',

        [theme.breakpoints.down("xs")]: {
            border: 'none',
            padding: '10px',
        },

        '& > div': {
            border: '2px solid #818181',
            height: '100%',
        },
    },
}));

export default (props) => {

    const classes = useStyles(props);
    const { direction, imgUrl, title } = props;

    return (
        <Grid container direction={direction} alignContent="center" justify="center">
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className={classes.bannerImg} style={{backgroundImage: 'url(' + config.S3Endpoint + imgUrl + ')'}}></div>
            </Grid>
            <Grid className={classes.bannerDescDiv} item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid container item alignItems="center" xs={12} className={classes.baneerTextContainer}>
                    <Grid container item alignItems="center">
                        <Grid item xs={12}>
                            <div className={classes.descTitle}>
                                <Typography variant="h3">{title}</Typography>
                            </div>
                            <div className={classes.descContent}>
                                {props.children}
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/room/DescFrame.js